import { baseUrl } from '../../../baseurl';
import { create } from 'zustand';
import axios from 'axios';
import { notification } from "antd";
export const useOrders = create((set, get) => ({

    allExchange: [],
    allMasterOrders: [],
    amlak: [],
    notAmlak: [],
    details: [],
    loader: false,
    orderImg: [],
    haveLike: false,
    nots: [],
    allDayes: [],
    notsByDate: [],
    detailForNote: [],
    notsForOrderByUserCode: [],
    comments: [],
    reportstatus: false,
    notsByMasterId: [],
    haveBookmark: [],
    resultSearch: [],
    orderCommnets: [],
    followResult: [],
    haveView: false,
    viewCount: "",
    showServerError: false,
    showClientError: false,
    advertiseByUserId: [],
    isFollow: [],
    usruserCode: 0,
    detailMasterByQuery: [],
    auctionDemandsByMasterIdAndUserId: [],
    iaActionPinned: [],
    adsMasterForUser: [],
    deleteAdsMasterRespons: false,
    auctionDemandRespons: false,
    calendarPrice: [],
    auctionRespons: false,
    isSearch: false,
    storeItems: [],
    hasMore: true,
    phoneNmberList: [],
    apiData: null,
    loginModal: false,
    storePage: 0,
    actions: {
        setApiData: (data) => set({ apiData: data }),
        setIsSearchFalse: (isSearch) => set({ isSearch: false }),
        addStoreItem: (newStoreItems) => {
            // Only add storeItems that are not already in the store
            const existingStoreItems = get().storeItems;
            const updatedStoreItems = [...existingStoreItems, ...newStoreItems.filter(item => !existingStoreItems.some(existingStoreItem => existingStoreItem.id === item.id))];
            set({ storeItems: updatedStoreItems });


        },
        setHasMoreStore: (hasMore) => set({ hasMore }),
        // b: () => {
        //     console.log("Clearing storeItems");
        //     set({ storeItems: [] });
        // },
        addItemsInStore: (items, currentPage) => {
            set({ storeItems: items })
            set({ storePage: currentPage })
            const x = get().storeItems;
        

        },
        clearStorePage: () => {
            set({ storePage: 0 })
        },
        clearStoreItems: () => {
            set({
                storeItems: [],
                storePage: 0 // Reset the page state when clearing items
            });
        },
        editUserReport: async (reportCode, usrUserCode, usrReportedUserCode, reportBody) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/User/EditUserReport`, {
                // "id": 0,
                "reportCode": reportCode,
                "usrUserCode": usrUserCode,
                "usrReportedUserCode": usrReportedUserCode,
                "reportBody": reportBody
            })
                .then((res) => {
                    set((state) => ({ loader: false }))
                    // set((state) => ({ nots: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsMasterRentBuyDetailByMasterId: async (masterId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterRentBuyDetailByMasterId?masterId=${masterId}`)
                .then((res) => {
                    if (res.data) {
                        set((state) => ({ details: res.data }))
                        set((state) => ({ usruserCode: res.data[0].usruserCode }))
                        set((state) => ({ loader: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getCalendarDayDetailByMasterId: async (masterID) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetCalendarDayDetailByMasterId?masterId=${masterID}`)
                .then((res) => {
                    set((state) => ({ calendarPrice: res.data }))
                }
                ).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        deleteAdsMaster: async (masterId, userId, DeleteReasonCode, DeleteDescription) => {

            set((state) => ({ loader: true }))
            await axios.delete(`${baseUrl}/Advertise/DeleteAdsMaster?MasterId=${masterId}&UserId=${userId}&DeleteReasonCode=${DeleteReasonCode}&DeleteDescription=${DeleteDescription}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ loader: false }))
                    if (res.status == 200) {
                        notification.success({
                            message: "آگهی برای شما تغییر یافت   ",
                            description: ``,
                            placement: "topRight",
                            className: "custom-notification"
                        });
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                ' دوباره تلاش کنید      ',
                        })
                    }
                    set((state) => ({ deleteAdsMasterRespons: res.data }))
                    setTimeout(() => {
                        set((state) => ({ deleteAdsMasterRespons: false }))
                    }, 2000);
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsMasterForUser: async (userId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterForUser?UserId=${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ adsMasterForUser: res.data }))
                    set((state) => ({ amlak: res.data.filter(item => item.adsMainCategoryCode === 1) }))
                    set((state) => ({ loader: false }))
                }
                ).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getDetailMasterByQueryByAllStrings: async (page, adsMainCategoryCode, userCode, adsAdvertiseTypeCode, adsPrptyTradeTypeCode, adsPrptyTypeCode, userTypeCode, countryCode,
            stateCode, cityCode, areaCode, priceFrom, priceTo, depositFrom, depositTo, rentFrom, rentTo,
            meterageFrom, meterageTo, buldingLifeFrom, buldingLifeTo, adsDateTimeFrom, adsDateTimeTo,
            parking, basement, elevator, searchQuery
        ) => {
            // set((state) => ({ loader: true }))
            await axios.post(`${baseUrl}/Advertise/GetDetailMasterByQuery`, {
                "page": page,
                "adsMainCategoryCode": adsMainCategoryCode,
                "userCode": userCode,
                "adsAdvertiseTypeCode": adsAdvertiseTypeCode,
                "adsPrptyTradeTypeCode": adsPrptyTradeTypeCode,
                "adsPrptyTypeCode": adsPrptyTypeCode,
                "userTypeCode": userTypeCode,
                "countryCode": countryCode,
                "stateCode": stateCode,
                "cityCode": cityCode,
                "areaCode": areaCode == [] ? [0] : areaCode,
                "priceFrom": priceFrom,
                "priceTo": priceTo,
                "depositFrom": depositFrom,
                "depositTo": depositTo,
                "rentFrom": rentFrom,
                "rentTo": rentTo,
                "meterageFrom": meterageFrom,
                "meterageTo": meterageTo,
                "buldingLifeFrom": buldingLifeFrom,
                "buldingLifeTo": buldingLifeTo,
                "adsDateTimeFrom": null,
                "adsDateTimeTo": null,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "searchQuery": searchQuery
            })
                .then((res) => {
                    set((state) => ({ allMasterOrders: res.data }))
                    set((state) => ({ isSearch: false }))
                    // set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsUserFollow: async (userId, adsMasterUserId) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseUrl}/User/GetAdsUserFollow`, {
                "userId": userId,
                "adsMasterUserId": adsMasterUserId
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.data) {
                        set((state) => ({ followResult: res.data }))
                        set((state) => ({ loader: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getExchange: async () => {
            await axios.get('https://api.pelakeman.com/api/Exchange/GetExchange')
                .then((res) => {
                    set((state) => ({ allExchange: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getMasterOrders: async () => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetMaster`)
                .then((res) => {
                    set((state) => ({ allMasterOrders: res.data }))
                    set((state) => ({ amlak: res.data.filter(item => item.adsMainCategoryCode === 1) }))
                    set((state) => ({ loader: false }))
                }
                ).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getDetailsOrders: async (masterId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterDetailByMasterId?masterId=${masterId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                }
            },)
                .then((res) => {
                    if (res.data) {
                        


                        set((state) => ({ details: res.data }))
                        set((state) => ({ usruserCode: res.data[0].usruserCode }))
                        set((state) => ({ phoneNmberList: res.data[0]?.tblAdsPhoneNumbers }))
                        set((state) => ({ loader: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showClientError: true }))
                })
        },
        getAdsPicMasterByMasterPriorityId: async (masterId, priority) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsPicMasterByMasterPriorityId?masterId=${masterId}&priority=${priority}`)
                .then((res) => {
                    // res.data.map(item => set((state) => ({ orderImg: [...state.orderImg, res.data] })))
                    set((state) => ({ orderImg: res.data }))
                    set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        setAdsMasterLike: async (adsMasterCode, adsUserCode) => {
            await axios.post(`${baseUrl}/Advertise/SetAdsMasterLike`, {
                "adsMasterCode": adsMasterCode,
                "adsUserCode": adsUserCode
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ haveLike: true }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsMasterLike: async (userId, masterId) => {
            set((state) => ({ loader: true }))
            userId = userId == null ? 0 : userId
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterLike?AdsMasterCode=${masterId}&UserusrCode=${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.data.id !== 0) {
                        set((state) => ({ haveLike: true }))
                    }
                    else {
                        set((state) => ({ haveLike: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        editAdsMasterNote: async (id, usrUserCode, adsMasterCode, noteTitle, noteBody, noteAddDate) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/Advertise/EditAdsMasterNote`, {
                "id": id,
                "usrUserCode": usrUserCode,
                "adsMasterCode": adsMasterCode,
                "noteTitle": noteTitle,
                "noteBody": noteBody,
                "noteAddDate": noteAddDate
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ loader: false }))
                    // set((state) => ({ nots: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsMasterNote: async (UserId) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterNote?UserId=${UserId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ nots: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        deleteAdsMasterById: async (noteId) => {
            set((state) => ({ loader: true }))
            await axios.delete(`${baseUrl}/Advertise/DeleteAdsMasterById?noteId=${noteId}`)
                .then((res) => {
                    set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsCalendar: async () => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsCalendar`)
                .then((res) => {
                    set((state) => ({ allDayes: res.data }))
                    set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsMasterNoteByDate: async (date) => {
            set((state) => ({ loader: true }))
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterNoteByDate?NoteDate=${date}`)
                .then((res) => {
                    set((state) => ({ nots: res.data }))
                    set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getDetailMasterByQuery: async (queryString) => {
            await axios.get(`${baseUrl}/Advertise/GetDetailMasterByQuery?${queryString}`)
                .then((res) => {
                    set((state) => ({ allMasterOrders: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsMasterJoinNote: async (userId, searchQuery) => {
            if (searchQuery) {
                set((state) => ({ loader: true }))
                await axios.get(`${baseUrl}/Advertise/GetAdsMaster_join_Note?UserID=${userId}&SearchQuery=${searchQuery}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                    .then((res) => {
                        set((state) => ({ notsForOrderByUserCode: res.data }))
                        set((state) => ({ loader: false }))
                    }).catch((err) => {
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                set((state) => ({ loader: true }))
                await axios.get(`${baseUrl}/Advertise/GetAdsMaster_join_Note?UserID=${userId}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                    .then((res) => {
                        set((state) => ({ notsForOrderByUserCode: res.data }))
                        set((state) => ({ loader: false }))
                    }).catch((err) => {
                        set((state) => ({ showServerError: true }))
                    })
            }
        },
        editAdsCommnet: async (id, adsMasterCode, usrUserCode, commentBody, dateAdded) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/Advertise/EditAdsCommnet`, {
                "id": id,
                "adsMasterCode": adsMasterCode,
                "usrUserCode": usrUserCode,
                "commentBody": commentBody,
                "dateAdded": dateAdded
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ loader: false }))
                    // set((state) => ({ nots: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsCommnetByMasterId: async (adsMasterCode) => {
            // set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/Advertise/GetAdsCommnetByMasterId`, {
                "masterID": adsMasterCode
            })
                .then((res) => {
                    set((state) => ({ comments: res.data }))
                    // set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },


        editAdsReport: async (id, advertiseReportCode, usrUserCode, adsMasterCode, reportBody) => {
            set((state) => ({ loader: true }))
            await axios.patch(`${baseUrl}/Advertise/EditAdsReport`, {
                "id": id,
                "advertiseReportCode": advertiseReportCode,
                "usrUserCode": usrUserCode,
                "adsMasterCode": adsMasterCode,
                "reportBody": reportBody
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    // if (res.status == 200) {
                    set((state) => ({ reportstatus: res.data }))
                    // }
                    set((state) => ({ loader: false }))
                }).catch((err) => {
                    // set((state) => ({ showServerError: true }))
                    set((state) => ({ loginModal: true }))
                    set((state) => ({ loader: false }))
                })
        },
        loginModalFalser: () => set({ loginModal: false }),
        getAdsMasterNoteByMasterId: async (userId, masterId) => {
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterNoteByMasterId?masterId=${masterId}&userId=${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ notsByMasterId: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        setAdsMasterUnLike: async (adsMasterCode, adsUserCode) => {
            await axios.post(`${baseUrl}/Advertise/SetAdsMasterUnLike`, {
                "adsMasterCode": adsMasterCode,
                "adsUserCode": adsUserCode
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ haveLike: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsMasterBookmark: async (userCode, masterId) => {
            userCode = userCode == null ? '' : userCode;
            await axios.get(`${baseUrl}/Advertise/GetAdsMasterBookmark?UsrUserCode=${userCode}&AdsMasterCode=${masterId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ haveBookmark: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        editAdsMasterBookmark: async (masterId, userCode) => {
            await axios.patch(`${baseUrl}/Advertise/EditAdsMasterBookmark`, {
                "id": 0,
                "usrUserCode": userCode,
                "adsMasterCode": masterId
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ haveBookmark: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        setAuctionDemand: async (usrUserCode, adsAuctionCode, isPersonVisit, isPriceSuggest, pricePerMeter, price, deposit, rentPerMonth) => {
            await axios.post(`${baseUrl}/AuctionDemand/SetAuctionDemand`, {
                "usrUserCode": usrUserCode,
                "adsAuctionCode": adsAuctionCode,
                "isPersonVisit": isPersonVisit,
                "isPriceSuggest": isPriceSuggest,
                "pricePerMeter": pricePerMeter,
                "totalPrice": price,
                "deposit": deposit,
                "rentPerMonth": rentPerMonth
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                  
                    set((state) => ({ auctionDemandRespons: res.data }))
                    // set((state) => ({ auctionRespons: true }))
                    setTimeout(() => {
                        set((state) => ({ auctionDemandRespons: false }))
                    }, 2000);
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        getAdsMasterSearch: async (searchTitile, adsMainCategoryCode) => {
            if (searchTitile) {
                set((state) => ({ loader: true }))
                set((state) => ({ isSearch: true }))

                await axios.get(`${baseUrl}/Advertise/GetAdsMasterSearch?searchQuery=${searchTitile}&adsMainCategoryCode=${adsMainCategoryCode}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                    .then((res) => {
                        set((state) => ({ allMasterOrders: res.data }))
                        set((state) => ({ adsMasterForUser: res.data }))
                        set((state) => ({ loader: false }))
                    }).catch((err) => {
                        set((state) => ({ showServerError: true }))
                    })
            } else {
                set((state) => ({ loader: true }))
                await axios.get(`${baseUrl}/Advertise/GetAdsMasterSearch?&adsMainCategoryCode=${adsMainCategoryCode}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                    .then((res) => {
                        set((state) => ({ allMasterOrders: res.data }))
                        set((state) => ({ loader: false }))
                    }).catch((err) => {
                        set((state) => ({ showServerError: true }))
                    })
            }
        },
        followToggle: async (followerUserId, followingUserId) => {
            await axios.post(`${baseUrl}/User/FollowToggle`, {
                "followerUserId": followerUserId,
                "followingUserId": followingUserId
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.data.id !== 0) {
                        set((state) => ({ followResult: res.data }))
                    } else {
                        set((state) => ({ followResult: res.data }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        editAdsView: async (usrUserCode, adsMasterCode) => {
            await axios.post(`${baseUrl}/Advertise/EditAdsView`, {
                "usrUserCode": usrUserCode,
                "adsMasterCode": adsMasterCode
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.data.id !== 0) {
                        set((state) => ({ haveView: true }))
                    } else {
                        set((state) => ({ haveView: false }))
                    }
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAdsMasterByUserId: async (userId) => {
            set((state) => ({ loader: true }))
            await axios.post(`${baseUrl}/Advertise/GetAdsMasterByUserId`, {
                "userId": userId,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ advertiseByUserId: res.data }))
                    set((state) => ({ loader: false }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getDetailMasterByQuery: async (adsPrptyTradeTypeCode, adsPrptyTypeCode) => {
            await axios.get(`${baseUrl}/Advertise/GetDetailMasterByQuery?AdsPrptyTradeTypeCode=${adsPrptyTradeTypeCode}&AdsPrptyTypeCode=${adsPrptyTypeCode}`)
                .then((res) => {
                    set((state) => ({ detailMasterByQuery: res.data }))
                    set((state) => ({ isSearch: false })) //melika 
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        getAuctionDemandsByMasterIdAndUserId: async (usrUserCode, adsMasterId) => {
            await axios.post(`${baseUrl}/AuctionDemand/GetAuctionDemandsByMasterIdAndUserId`, {
                "usrUserCode": usrUserCode,
                "adsMasterId": adsMasterId,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ auctionDemandsByMasterIdAndUserId: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        editAuctionDemandPinned: async (usrUserCode, auctionDemandId) => {
            await axios.post(`${baseUrl}/AuctionDemand/EditAuctionDemandPinned`, {
                "usrUserCode": usrUserCode,
                "auctionDemandId": auctionDemandId
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    set((state) => ({ iaActionPinned: res.data }))
                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },

        addAdsSeenByUser: async (adsMasterId) => {
            await axios.post(`${baseUrl}/Advertise/AddAdsSeenByUser`, {
                "adsMasterId": adsMasterId,
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                   

                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        EditforSelf: async (usruserCode, adsMasterCode, countryCode, stateCode, cityCode, areaCode, latitude, longitude, isApproximateArea, adsTitle, pricePerMeter, totalPrice,
            propertyLandMetarage, propertyWidth, deposit, squareFootageEntireProperty, rentPerMonth, abilityToConvert, convertingDepositAmount, convertingRentAmount,
            meterage, numberOfRooms, lifeOfTheBuilding, dateForRent,
            floorNumber, totalFloor, unitPerFloor, parking, basement, elevator, mobilePhone, landPhone, price, description, adsDateTime, isDeleted, registerStatusCode, searchStrings, ownerName, address, addedBy, updatedBy, updatedAt
        ) => {
            await axios.post(`${baseUrl}/Advertise/UpdateAdsMasterEdit`, {
                "usruserCode": usruserCode,
                "adsMasterCode": adsMasterCode,
                "countryCode": countryCode,
                "stateCode": stateCode,
                "cityCode": cityCode,
                "areaCode": areaCode,
                "latitude": latitude,
                "longitude": longitude,
                "isApproximateArea": isApproximateArea,
                "adsTitle": adsTitle,
                "pricePerMeter": pricePerMeter,
                "totalPrice": totalPrice,
                "propertyLandMetarage": propertyLandMetarage,
                "propertyWidth": propertyWidth,
                "deposit": deposit,
                "squareFootageEntireProperty": squareFootageEntireProperty,
                "rentPerMonth": rentPerMonth,
                "abilityToConvert": abilityToConvert,
                "convertingDepositAmount": convertingDepositAmount,
                "convertingRentAmount": convertingRentAmount,
                "meterage": meterage,
                "numberOfRooms": numberOfRooms,
                "lifeOfTheBuilding": lifeOfTheBuilding,
                "dateForRent": dateForRent,
                "floorNumber": floorNumber,
                "totalFloor": totalFloor,
                "unitPerFloor": unitPerFloor,
                "parking": parking,
                "basement": basement,
                "elevator": elevator,
                "mobilePhone": mobilePhone,
                "landPhone": landPhone,
                "price": price,
                "description": description,
                "adsDateTime": adsDateTime,
                "isDeleted": isDeleted,
                "registerStatusCode": registerStatusCode,
                "searchStrings": searchStrings,
                "ownerName": ownerName,
                "address": address,
                "addedBy": addedBy,
                "updatedBy": updatedBy,
                "updatedAt": updatedAt
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                   
                    if (res.status == 200) {
                        notification.success({
                            message: "آگهی برای شما تغییر یافت   ",
                            description: ``,
                            placement: "topRight",
                            className: "custom-notification"
                        });
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                ' دوباره تلاش کنید      ',
                        })
                    }

                }).catch((err) => {
                    set((state) => ({ showServerError: true }))
                })
        },
        clearReportStatus: () => {
            set((state) => ({ reportstatus: false }));
        },

    }
}))